import { useEffect, useState } from "react";
import searchApi from '@/service/modules/schemeApi'
import dayjs from 'dayjs'
import DefaultLayout from "@/components/DefaultLayout"
import styles from "@/styles/scheme.module.scss"
import SliderBarRight from "@/components/SliderBarRight";
import SliderBarLeft from "@/components/SliderBarLeft";
import ShopInfo from "@/components/ShopInfo"
import BreadCrumEle from "@/components/global/BreadCrum";
import FilterBarScheme from '@/components/FilterBarScheme'
import { Empty, Row, Skeleton } from "antd"
import GoodsComponentWithDiscountNew from "@/components/GoodsComponentWithDiscountNew";
import { useRouter } from "next/router";
import GoogleADSense from "@/components/GoogleADSense"
import InfiniteScroll from "react-infinite-scroll-component";
import { fillterBarDictionary } from "@/utils/dictionary"
import Head from "next/head"
import schemeApi from "@/service/modules/schemeApi";
import InfiniteLoader from "@/components/InfiniteLoader";

interface BreadcrumbItem {
  name: string;
  url: string;
  current: boolean;
}

interface BreadCrum {
  breadCrumb: Array<BreadcrumbItem>
  categoryID: string
}

interface FilterItems {
  categoryID: number;
  count: number;
  icon: string;
  name: string;
  parent: number;
  url: string;
}
interface sidebarFilterItem {
  key: string
  title: string
  items: Array<FilterItems>
}
interface Sidebar {
  sidebarFilter: Array<sidebarFilterItem>
}

interface PageList {
  currentPage: number;
  items: any[]
  lastPage: number;
  perPage: number;
  total: number;
}
interface SchemeInfo {
  pageList: PageList
  scheme: {
    title: string;
    metaDescription: string;
    metaKeywords: string;
    logoUrl: string
  }
}
interface Props {
  pageList: SchemeInfo;
  schemeBreadcrumb: BreadCrum;
  schemeSidebar: Sidebar;
}

interface DAMNU_ENABLE {
  [key: string]: any, // 字段扩展声明
}

export default function SpecialPromotions() {
  const schemeBreadcrumb = { breadCrumb: [{
    name: "Special Promotions",
    url: "/special-promotions",
    current: true
  }] }
  const [listInfo, setListInfo] = useState([])
  // const [productList] = useState(pageList.pageList.items)
  const [productListClient, setProductListClient] = useState([])
  const [breadCrumb] = useState(schemeBreadcrumb.breadCrumb)
  const [sidebar, setSideBar] = useState<any>({ sidebarFilter: [] })
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize] = useState(20)
  // const [total, setTotal] = useState(0)
  const [isFinsh, setIsFinsh] = useState(false)
  const [isEmpty, setIsEmpty] = useState(false)
  const [isFirst, setIsFirst] = useState(true)
  const router = useRouter();
  const [filterBarData, setFilterBarData] = useState<DAMNU_ENABLE>({})
  useEffect(() => {
    // if (isFirst) {
    //   setIsFirst(false)
    //   return
    // }
    getProductList()
  }, [pageSize, currentPage, filterBarData])

  const getFilterData = async () => {
    try {
      const res = await schemeApi.getSpecialPromotionFilter()
      const { sidebarFilter } = res.data
      setSideBar({ sidebarFilter })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getFilterData()
  }, [])

  const getProductList = async () => {
    setLoading(true)
    let params: any = {
      page: currentPage,
      perPage: pageSize,
    }
    // 遍历左侧对象
    for (const key in filterBarData) {
      if (Object.prototype.hasOwnProperty.call(filterBarData, key)) {
        const element = filterBarData[key];

        // 判断属于哪个类目下，传参有所不同
        if (fillterBarDictionary.getValueByKey(element.key) === 1) {
          params.sortBy = element.sortBy
          params.sortDirection = element.direction
        }
        if (fillterBarDictionary.getValueByKey(element.key) === 2) {
          params.minPrice = element.minPrice
          params.maxPrice = element.maxPrice
        }
        if (fillterBarDictionary.getValueByKey(element.key) === 3) {
          params.brand = element.name
        }
        if (fillterBarDictionary.getValueByKey(element.key) === 4) {
          params.categoryID = element.categoryID
        }


        // 没字典特殊的统一处理
        if (!fillterBarDictionary.getValueByKey(element.key)) {
          params.categoryID = element.categoryID
        }
      }
    }

     const res = await schemeApi.getSpecialPromotions(params)
     const productInfo = res.data
    setListInfo(productInfo)
    setProductListClient(productListClient.concat(productInfo.pageList.items))
    // setTotal(productInfo.pageList.total)
    setIsFinsh(productInfo.pageList.items.length < pageSize)
    setIsEmpty(productInfo.pageList.items.length == 0)
    setLoading(false)
  }


  // 左侧筛选处理
  const filterBarChange = (item: any) => {
    let data = filterBarData

    // 重复选需要删除
    if (JSON.stringify(data[item.key]) == JSON.stringify(item)) {
      delete data[item.key]
    } else {
      // Price Range与Hot Brands是相互冲突的
      // if (fillterBarDictionary.getValueByKey(item.key) != 1) {
      //   for (const key in data) {
      //     if (Object.prototype.hasOwnProperty.call(data, key)) {
      //       // 判断不为custom-filtering的都互斥
      //       fillterBarDictionary.getValueByKey(key) != 1 && delete data[key]
      //     }
      //   }
      // }
      data = { ...filterBarData, [item.key]: item }
    }

    setProductListClient([])
    setCurrentPage(1)
    setIsFinsh(false)
    setFilterBarData({ ...data })
  }

  const handleScroll = () => {

    const targetElement = document.getElementById("product-list-id")

    if (targetElement) {
      // 获取目标元素的位置信息
      const targetElementRect = targetElement.getBoundingClientRect();

      // 获取窗口的滚动位置
      const scrollPosition = window.scrollY || window.pageYOffset;

      // 判断窗口是否已经移动到目标元素底部
      if (scrollPosition + window.innerHeight >= targetElementRect.bottom + scrollPosition) {
        // 在这里触发加载事件
        if (!loading && !isFinsh) {
          setCurrentPage(currentPage + 1)
        }
      }
    }
  };
  return (
    <>
      <Head>
        <title>{`Special Promotions - Crazy Sales`}</title>
        <meta name="keywords" content={`on promotion, specials, sale, special promotions, clearance, bargain, crazy sales`}></meta>
        <meta name="description" content={`Looking for a cheap deal on a whole range of products? You've come to the right web page! Crazy Sales Australia offers up wholesale prices on a whole range of products from electronic gadgets, to toys for kids of all ages, to perfumes, vitamins, awesome g`}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles['scheme-box']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          {/* 面包屑 */}
          {
            !!(breadCrumb && breadCrumb.length) &&
            <BreadCrumEle BreadList={breadCrumb}></BreadCrumEle>
          }

          {/* 商城特色介绍 */}
          <div className={styles['shop-info-box']}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <div className={styles['content-box']}>
            <div className={styles['left']}>
              <FilterBarScheme onChange={filterBarChange} filterBarData={filterBarData} sidebarData={sidebar} />

            </div>

            <div className={styles['right']}>
              <InfiniteScroll
                dataLength={productListClient.length}
                next={() => { }}
                hasMore={!isFinsh}
                onScroll={handleScroll}
                endMessage={
                  <>
                    {/* {
                  !isEmpty
                  &&
                  <p style={{ textAlign: 'center' }}>
                    <b>Yay! You have seen it all</b>
                  </p>
                } */}
                  </>
                }
                loader={
                  <>
                    {
                      loading
                      &&
                      <Row justify={"center"} style={{ padding: "16px 0" }}>
                        <InfiniteLoader />
                      </Row>
                    }
                  </>
                }
              >
                <div className={styles['product-list']} id="product-list-id">
                  {
                    productListClient.length > 0
                      ?
                      productListClient.map((item: any) => (
                        <div className={styles['product-list-item']} key={item.productID}>
                          <GoodsComponentWithDiscountNew {...item} imgUrl={item.filename} productName={item.name} />
                        </div>
                      ))
                      :
                      <>
                        {
                          (isEmpty && !loading)
                            ?
                            <Empty style={{ 'flexBasis': '100%' }} />
                            :
                            <Skeleton active />
                        }
                      </>
                  }
                  <div className={styles['product-list-item']}></div>
                  <div className={styles['product-list-item']}></div>
                  <div className={styles['product-list-item']}></div>
                </div>
              </InfiniteScroll>

              <GoogleADSense />
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}